interface StepBarProps {
  left: string;
  /** Omit to let the rule run to the edge with nothing after it. */
  right?: string;
}

/** The mono label / rule / mono label row that heads every panel. */
export default function StepBar({ left, right }: StepBarProps) {
  return (
    <div className="step">
      <span className="mono">{left}</span>
      <span className="bar" />
      {right ? <span className="mono">{right}</span> : null}
    </div>
  );
}
